import TaskListPage from '@pages/team/[teamId]/workspace/tasks';
import TaskDetailsPage from '@pages/team/[teamId]/workspace/tasks/[taskId]';
import AgentRunDetailsPage from '@pages/team/[teamId]/workspace/tasks/[taskId]/agent-runs/[agentRunId]';

export const taskRoutes = {
  path: 'tasks',
  children: [
    { path: '', element: <TaskListPage /> },
    { path: ':taskId', element: <TaskDetailsPage /> },
    {
      path: ':taskId/agent-runs/:agentRunId',
      element: <AgentRunDetailsPage />,
    },
  ],
};
